import { RenterNextScheduleMonthInterface, RenterNextScheduleMonthNumericInputInterface } from './Types';
import { formatTimestampToYMDString } from '@common/paymentsUtils/dateUtils';

const NextScheduleMonthModel = (
  nextScheduleMonth: RenterNextScheduleMonthNumericInputInterface,
): RenterNextScheduleMonthInterface => {
  const {
    scheduleMonth = '',
    dueDate = 0,
    numberOfPaymentsRemaining = 0,
    amount = 0,
    totalAmount = 0,
  } = nextScheduleMonth || {};

  return {
    scheduleMonth,
    dueDate: formatTimestampToYMDString(dueDate),
    numberOfPaymentsRemaining: numberOfPaymentsRemaining && Number(numberOfPaymentsRemaining),
    amount: amount && Number(amount),
    totalAmount: totalAmount && Number(totalAmount),
  };
};

export default NextScheduleMonthModel;
